// removed by extract-text-webpack-plugin
module.exports = {"commentList":"_3iCxm","separator":"_33fbR"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-list/comment-list.scss
// module id = 1702
// module chunks = 0